import T from '@/components/Helpers/Translate'
import { useGetStoreCredit } from '@/lib/hooks/services/useGetStoreCredit'
import useGlobalStore from '@/store/useGlobalStore'

const AccountMenuStoreCredit = () => {
  const {
    user: { formattedStoreCredit },
  } = useGlobalStore()

  useGetStoreCredit()

  if (!formattedStoreCredit) return null

  return (
    <div className="rounded-lg bg-sky-100 p-5 text-sm text-primary">
      <span>
        <T>product_credit</T>
      </span>
      : <strong>{formattedStoreCredit}</strong>
    </div>
  )
}

export default AccountMenuStoreCredit
